import { connect } from 'react-redux'
import activitiesSelector from './activitiesSelector'
import { sagaActions as rootSagaActions } from 'store/sagas'
import { sagaActions } from '../../sagas'
import Activities from './Activities'

export default connect(
  activitiesSelector,
  {
    requestChangeUserSettings: rootSagaActions.requestChangeUserSettings,
    requestMarkBoardAsRead: sagaActions.requestMarkBoardAsRead,
  }
)(Activities)
